/**
 * Song Processing Active/Archived tab badge consistency.
 *
 * After bulk uploads, dense COUNTER#LIST can lag the rows already loaded on
 * the page. The table "Showing X of Y" already floors Y with visible rows;
 * tab badges must do the same so Active (37) never contradicts 51 visible jobs.
 */

/** Prefer server count; never show fewer than rows already visible on this tab. */
export function floorLifecycleTabCount(
  serverCount: number | undefined,
  visibleOnCurrentTab: number,
): number | undefined {
  if (serverCount == null || serverCount < 0) {
    return visibleOnCurrentTab > 0 ? visibleOnCurrentTab : undefined;
  }
  return Math.max(serverCount, visibleOnCurrentTab);
}

/** True when the page already shows more rows than the authoritative counter. */
export function shouldRefetchLifecycleTabCount(
  serverCount: number | undefined,
  visibleOnCurrentTab: number,
): boolean {
  return (
    serverCount != null &&
    serverCount >= 0 &&
    visibleOnCurrentTab > serverCount
  );
}
